<template>
  <div class="sign-up_container">
    <UrgentBanner
      type="Success!!"
      message="Unable to verify your account. Please retry logging in."
      v-if="showBanner === true"
    />
    <form class="sign-up_form">
      <div class="wcf-details_container">
        <img id="wcf-logo" src="../assets/logo.png" />
        <p class="wcf-text">Winners Campus Fellowship</p>
      </div>
      <div class="form-details">
        <h2 class="form-header">Verifying your account...</h2>
        <p class="instruction-text">
          Once your account has been verified, you will be taken to the profile
          page to select a profile photo
        </p>
      </div>
    </form>
  </div>
</template>

<script>
// @ is an alias to /src
import UrgentBanner from "@/components/UrgentBanner.vue";

export default {
  name: "VerifySignIn",
  data() {
    return {
      showBanner: false,
    };
  },
  components: {
    UrgentBanner,
  },
};
</script>

<style lang="scss" scoped>
:root {
  --font-size-small: 0.926vw;
  --font-size-medium: 2.778vw;
  --black: #000;
  --grey: rgba(0, 0, 0, 0.7);
  --light-grey: rgba(0, 0, 0, 0.5);
  --least-heavy: 400;
  --medium-heavy: 500;
  --heavy: 700;
  --vertical-gap: 2.149vh;
  --horizontal-gap: 1.389vw;
  --accent-colour: #f40200;
}

.sign-up_container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  form.sign-up_form {
    width: fit-content;
    height: fit-content;
    display: flex;
    flex-direction: column;
    max-width: 51.389vw;
    align-items: center;
    .wcf-details_container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--vertical-gap);
      img {
        width: 4.34vw;
        height: auto;
      }
      p {
        color: var(--grey);
        font-family: "DM Sans";
        font-size: var(--font-size-small);
        font-style: normal;
        font-weight: var(--least-heavy);
        line-height: normal;
      }
    }
    .form-details {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 33.796vw;
      gap: var(--vertical-gap);
      padding: var(--vertical-gap) var(--horizontal-gap);
      h2 {
        color: var(--black);
        font-family: "DM Sans";
        font-size: var(--font-size-medium);
        font-style: normal;
        font-weight: var(--medium-heavy);
        line-height: normal;
        letter-spacing: -0.111vw;
        text-align: center;
      }
      p.instruction-text {
        color: var(--black);
        text-align: center;
        font-family: "DM Sans";
        font-size: var(--font-size-small);
        font-style: normal;
        font-weight: var(--least-heavy);
        line-height: normal;
      }
    }
  }
}
</style>
